import { createAsyncActions } from '../../utils';

export const trackerConstants = {
  SET_CANDIDATES_CONNECTED: '@@tracker/SET_CANDIDATES_CONNECTED',
  SET_CANDIDATES_APPLIED: '@@tracker/SET_CANDIDATES_APPLIED',
  SET_CANDIDATES_HIRED: '@@tracker/SET_CANDIDATES_HIRED',
  LOAD_CANDIDATES_CONNECTED: createAsyncActions(
    '@@tracker/LOAD_CANDIDATES_CONNECTED',
  ),
  LOAD_CANDIDATES_APPLIED: createAsyncActions(
    '@@tracker/LOAD_CANDIDATES_APPLIED',
  ),
  LOAD_CANDIDATES_HIRED: createAsyncActions('@@tracker/LOAD_CANDIDATES_HIRED'),
};

export const trackerActions = {
  setCandidatesConnectedData: (payload) => ({
    type: trackerConstants.SET_CANDIDATES_CONNECTED,
    payload,
  }),
  setCandidatesAppliedData: (payload) => ({
    type: trackerConstants.SET_CANDIDATES_APPLIED,
    payload,
  }),
  setCandidatesHiredData: (payload) => ({
    type: trackerConstants.SET_CANDIDATES_HIRED,
    payload,
  }),
  getCandidatesConnectedData: (payload) => ({
    type: trackerConstants.LOAD_CANDIDATES_CONNECTED.TRIGGER,
    payload,
  }),
  getCandidatesAppliedData: (payload) => ({
    type: trackerConstants.LOAD_CANDIDATES_APPLIED.TRIGGER,
    payload,
  }),
  getCandidatesHiredData: (payload) => ({
    type: trackerConstants.LOAD_CANDIDATES_HIRED.TRIGGER,
    payload,
  }),
};
